/**
 * KITCHNEST custom analytics events.
 *
 * Shopify's standard customer events (page_viewed, product_viewed, search_submitted,
 * product_added_to_cart, checkout_started, checkout_completed) already fire natively,
 * so they are NOT re-sent here (avoids double counting). This module only publishes
 * KITCHNEST-specific custom events through Shopify's Customer Events API
 * (`Shopify.analytics.publish`), which web pixels can subscribe to with consent handling
 * done by Shopify. Nothing is sent when the API is unavailable.
 */
import { StandardEvents } from '@shopify/events';

const publish = (name, detail) => {
  try {
    window.Shopify?.analytics?.publish?.(name, detail);
  } catch (_) {
    /* analytics must never break shopping */
  }
};

const thresholdCents = Math.round(Number(window.Theme?.kitchnest?.FREE_SHIPPING_THRESHOLD ?? 1450) * 100);
const SESSION_KEY = 'kn_fs_unlocked';

const readSession = () => {
  try {
    return sessionStorage.getItem(SESSION_KEY) === '1';
  } catch (_) {
    return false;
  }
};
const writeSession = (value) => {
  try {
    if (value) sessionStorage.setItem(SESSION_KEY, '1');
    else sessionStorage.removeItem(SESSION_KEY);
  } catch (_) {}
};

/** @param {number} totalCents */
function trackThreshold(totalCents) {
  if (window.Theme?.kitchnest?.currency && window.Theme.kitchnest.currency !== 'ZAR') return;
  const unlocked = totalCents >= thresholdCents;
  const already = readSession();
  if (unlocked && !already) {
    writeSession(true);
    publish('kitchnest_free_shipping_unlocked', { cart_total_cents: totalCents, threshold_cents: thresholdCents });
  } else if (!unlocked && already) {
    writeSession(false);
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(({ cart }) => {
      const total = Number(cart?.cost?.totalAmount?.amount ?? cart?.cost?.subtotalAmount?.amount);
      if (Number.isFinite(total)) trackThreshold(Math.round(total * 100));
    })
    .catch(() => {});
});

document.addEventListener('kitchnest:upsell-added', (event) => {
  publish('kitchnest_cart_upsell_added', event.detail || {});
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  const wrap = form instanceof HTMLFormElement ? form.closest('[data-kn-newsletter]') : null;
  if (wrap instanceof HTMLElement) {
    publish('kitchnest_newsletter_submit', { location: wrap.dataset.knNewsletter || 'unknown' });
  }
});

// Cart drawer opens
const drawer = document.querySelector('#cart-drawer dialog');
if (drawer) {
  new MutationObserver(() => {
    if (drawer.hasAttribute('open')) publish('kitchnest_cart_drawer_opened', {});
  }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
}
